<!DOCTYPE html>
<mat-tab-group #matTabGroup [selectedIndex]="currentTab" class="comm-mat-tab">
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="tab-labels">Stream</span>
    </ng-template>
    @if (url1) {
      <iframe [src]="url1" frameborder="0" class="stream-iframe" (load)="loading('stream')"></iframe>
    }
    <!-- content -->
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="tab-labels"> Photos</span>
    </ng-template>
    @if (url2) {
      <iframe [src]="url2" frameborder="0" class="stream-iframe" (load)="loading('stream')"></iframe>
    }
    <!-- content -->
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="tab-labels"> Followers</span>
    </ng-template>
    @if (url3) {
      <iframe [src]="url3" frameborder="0" class="stream-iframe" (load)="loading('stream')"></iframe>
    }
    <!-- content -->
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="tab-labels"> Groups</span>
    </ng-template>
    @if (url4) {
      <iframe [src]="url4" frameborder="0" class="stream-iframe" (load)="loading('stream')"></iframe>
    }
    <!-- content -->
  </mat-tab>
</mat-tab-group>
@if ($streamLoader | async; as load) {
  @if (load === 'load') {
    <div>
      <app-in-progress-animation type="stream" class="skeleton"></app-in-progress-animation>
    </div>
  }
}
